import React, { useState } from 'react';

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header className="bg-gray-900 text-white sticky top-0 z-50 shadow-lg">
            <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
                {/* Logo */}
                <a href="/" className="flex items-center space-x-2">
                    <img src="/LogoEnsure.png" alt="YuktiEnsure Logo" className="h-20 w-auto" />
                </a>

                <div className="hidden md:flex items-center space-x-8">
                    <div className="relative group">
                        <button className="nav-link">For Business</button>
                        <div className="absolute left-0 mt-2 w-56 bg-white text-gray-800 rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 invisible group-hover:visible">
                            <a href="#property" className="block px-4 py-2 hover:bg-gray-100">Property & Asset</a>
                            <a href="#employee" className="block px-4 py-2 hover:bg-gray-100">Employee Benefits</a>
                            <a href="#liability" className="block px-4 py-2 hover:bg-gray-100">Liability & Risks</a>
                            <a href="#marine" className="block px-4 py-2 hover:bg-gray-100">Marine & Cargo</a>
                            <a href="#engineering" className="block px-4 py-2 hover:bg-gray-100">Engineering</a>
                            <a href="#trade-credit" className="block px-4 py-2 hover:bg-gray-100">Trade Credit</a>
                        </div>
                    </div>
                    <a href="#life" className="nav-link">For Individuals</a>
                    <a href="#knowledge" className="nav-link">Knowledge Centre</a>
                    <a href="#contact" className="nav-link">Contact Us</a>
                    <a href="#contact" className="btn-gold font-bold py-2 px-4 rounded-full transition duration-300">
                        Get a Consultation
                    </a>
                </div>
                <div className="md:hidden">
                    <button id="mobile-menu-button" className="text-white focus:outline-none" onClick={toggleMobileMenu}>
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path></svg>
                    </button>
                </div>
            </nav>
            {/* Mobile Menu */}
            <div id="mobile-menu" className={`md:hidden px-4 pb-4 ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
                <a href="#property" className="block py-2">Property & Asset</a>
                <a href="#employee" className="block py-2">Employee Benefits</a>
                <a href="#liability" className="block py-2">Liability & Risks</a>
                <a href="#marine" className="block py-2">Marine & Cargo</a>
                <a href="#engineering" className="block py-2">Engineering</a>
                <a href="#trade-credit" className="block py-2">Trade Credit</a>
                <a href="#life" className="block py-2">For Individuals</a>
                <a href="#knowledge" className="block py-2">Knowledge Centre</a>
                <a href="#contact" className="block py-2">Contact Us</a>
                <a href="#contact" className="block mt-2 btn-gold text-center font-bold py-2 px-4 rounded-full transition duration-300">Get a Consultation</a>
            </div>
        </header>
    );
};

export default Header;